import axios from 'axios';
import https from 'https';

const httpsAgent = new https.Agent({
	rejectUnauthorized: false,
});
const instance = axios.create({
	baseURL: `${process.env.VUE_APP_APIURL}/api/airlee`,
	httpsAgent,
});

export default {
	namespaced: true,
	state: {},
	actions: {
		setMedPart(context, status) {
			context.commit('SET_MED_PART', status);
		},
		setMedProblem(context, status) {
			context.commit('SET_MED_PROBLEM', status);
		},
		setMed(context, status) {
			context.commit('SET_MED', status);
		},
		setMedBooking(context, status) {
			context.commit('SET_MED_BOOKING', status);
		},
		setRoom(context, status) {
			context.commit('SET_ROOM', status);
		},
		setBooking(context, status) {
			context.commit('SET_BOOKING', status);
		},
		setTime(context, status) {
			context.commit('SET_TIME', status);
		},
		setNote(context, status) {
			context.commit('SET_NOTE', status);
		},
		setCusNote(context, status) {
			context.commit('SET_CUS_NOTE', status);
		},
		setParts(context, status) {
			context.commit('SET_PARTS', status);
		},
		setRegistrations(context, status) {
			context.commit('REGISTRATIONS', status);
		},
		searchCustomer(context, status) {
			return new Promise((resolve, reject) => {
				const { data, clinicCode } = status;
				const api = `/resv/customers/search`;
				context.commit('LOADING', true, { root: true });
				instance({
					method: 'post',
					url: api,
					data: data,
					headers: { clinic_code: clinicCode },
				})
					.then((res) => {
						if (res.data.status == 'error') {
							// dont remove tr
							context.commit('LOADING', false, { root: true });
							reject(res.data.msg);
						} else {
							context.commit('LOADING', false, { root: true });
							const { customers, newpatients } = res.data.data;
							if (customers.length == 0 && newpatients.length == 0) {
								const nnp = {
									birthday: data.birthday,
									name: data.name,
									mobile: data.mobile,
								};
								context.commit('SET_AIRLEE_NNP', { nnp, clinicCode });
								resolve({ customers, newpatients, nnp });
							} else {
								resolve({ customers, newpatients });
							}
						}
					})
					.catch((err) => {
						context.commit('LOADING', false, { root: true });
						if (err.response.data.status == 'failed') {
							const error = new Error(err.response.data.message);
							reject(error);
						} else {
							reject(err);
						}
					});
			});
		},
		checkCustomer(context, status) {
			return new Promise((resolve, reject) => {
				const { data, clinicCode } = status;
				const api = `/resv/customers/check`;
				context.commit('LOADING', true, { root: true });
				instance({
					method: 'post',
					url: api,
					data: data,
					headers: { clinic_code: clinicCode },
				})
					.then((res) => {
						if (res.data.status == 'error') {
							// dont remove tr
							context.commit('LOADING', false, { root: true });
							reject(res.data.msg);
						} else {
							let { customer, registrations, newpatient, token } =
								res.data.data;
							if (!customer) {
								customer = {};
							}
							if (!registrations) {
								registrations = [];
							} else {
								// 若有MGM推薦碼資料，則處理相關資料
								if (registrations.length > 0) {
									registrations.forEach((reg) => {
										if (reg.mgm && reg.mgm?.response) {
											reg.mgm.response = reg.mgm?.response || {};
											// 獎勵資訊
											reg.mgm.referee =
												reg.mgm.response?.res_data?.campaign_info?.reward
													?.referee || '';
										}
									});
								}
							}
							if (!newpatient) {
								newpatient = {};
							}
							context.commit('SET_AIRLEE_CUSTOMER', {
								data: customer,
								clinicCode,
							});
							context.commit('SET_AIRLEE_REGISTRATIONS', {
								registrations: registrations,
								clinicCode,
							});
							context.commit('SET_AIRLEE_NEWPATIENT', {
								data: newpatient,
								clinicCode,
							});
							context.commit('SET_AIRLEE_NNP', {
								nnp: {
									birthday: data.birthday,
									mobile: data.mobile,
									name: data.name,
								},
								clinicCode,
							});
							context.commit(
								'TOKEN',
								{ data: token, clinicCode },
								{ root: true },
							);
							context.commit('LOADING', false, { root: true });
							resolve(res.data.data);
						}
					})
					.catch((err) => {
						context.commit('LOADING', false, { root: true });
						reject(err);
					});
			});
		},
		checkHqOp(context, status) {
			return new Promise((resolve, reject) => {
				const { data } = status;
				const payload = {
					cusmob: data.cusmob,
				};
				const api = `/customer/check_hq_op`;
				context.commit('LOADING', true, { root: true });
				instance({
					method: 'post',
					url: api,
					data: payload,
				})
					.then((res) => {
						if (res.data.status === 'error') {
							context.commit('LOADING', false, { root: true });
							reject(res.data.msg);
						} else {
							context.commit('LOADING', false, { root: true });
							if (res.data.is_hq_op) {
								resolve(true);
							} else {
								resolve(false);
							}
						}
					})
					.catch((err) => {
						context.commit('LOADING', false, { root: true });
						reject(err);
					});
			});
		},
		getResvList(context, status) {
			let room = {};
			let time = {};
			let clinicCode = '';
			if (localStorage.getItem('clinicCode')) {
				clinicCode = localStorage.getItem('clinicCode');
			}
			if (localStorage.getItem(`room_airlee_${clinicCode}`)) {
				room = JSON.parse(localStorage.getItem(`room_airlee_${clinicCode}`));
			}
			if (localStorage.getItem(`time_airlee_${clinicCode}`)) {
				time = JSON.parse(localStorage.getItem(`time_airlee_${clinicCode}`));
			}
			return new Promise((resolve, reject) => {
				const api = `/resv/quick_resv`;
				context.commit('LOADING', true, { root: true });
				status.append('room_no', room.no);
				status.append('period', time.schlen);
				status.append('checkin', time.checkin);
				instance({
					method: 'post',
					url: api,
					data: status,
					headers: { clinic_code: clinicCode },
				})
					.then((res) => {
						if (res.data.status == 'error' || res.data.status == 'failed') {
							reject(res.data.msg);
						} else {
							context.commit('RESV_LIST', res.data.data);
							resolve(res.data.data);
						}
						context.commit('LOADING', false, { root: true });
					})
					.catch((err) => {
						context.commit('LOADING', false, { root: true });
						reject(err);
					});
			});
		},
		sendResv(context, status) {
			return new Promise((resolve, reject) => {
				const { data, clinicCode } = status;
				const api = `/resv/resvs`;
				context.commit('LOADING', true, { root: true });
				instance({
					method: 'post',
					url: api,
					data: data.payload,
					headers: { clinic_code: clinicCode },
				})
					.then((res) => {
						if (res.data.status == 'error') {
							context.commit('LOADING', false, { root: true });
							reject(res.data.msg);
						} else {
							context.commit('RESV', { data: data.resv, clinicCode });
							context.commit('LOADING', false, { root: true });
							resolve(res);
						}
					})
					.catch((err) => {
						context.commit('LOADING', false, { root: true });
						if (err.response.data.status == 'failed') {
							reject(err.response.data.message);
						}
						reject(err);
					});
			});
		},
		cancelResv(context, status) {
			return new Promise((resolve, reject) => {
				const { data, clinicCode } = status;
				const api = `/resv/resvs/${data.regsn}`;
				context.commit('LOADING', true, { root: true });
				instance({
					method: 'post',
					url: api,
					data: data.fd,
					headers: { clinic_code: clinicCode },
				})
					.then((res) => {
						if (res.data.status == 'error') {
							// dont remove tr
							context.commit('LOADING', false, { root: true });
							reject(res.data.msg);
						} else {
							// remove tr
							context.commit('RM_REGISTRATION', {
								data: data.regsn,
								clinicCode,
							});
							context.commit('LOADING', false, { root: true });
							resolve(res);
						}
					})
					.catch((err) => {
						context.commit('LOADING', false, { root: true });
						reject(err);
					});
			});
		},
		// 清除預約資訊
		clearResv(context, status) {
			const { clinicCode } = status;
			localStorage.removeItem(`med_airlee_${clinicCode}`);
			localStorage.removeItem(`med_part_airlee_${clinicCode}`);
			localStorage.removeItem(`med_problem_airlee_${clinicCode}`);
			localStorage.removeItem(`room_airlee_${clinicCode}`);
			localStorage.removeItem(`time_airlee_${clinicCode}`);
			localStorage.removeItem(`note_airlee_${clinicCode}`);
			localStorage.removeItem(`cus_note_airlee_${clinicCode}`);
			localStorage.removeItem(`registrations_airlee_${clinicCode}`);
			localStorage.removeItem(`resv_airlee_${clinicCode}`);
		},
	},
	mutations: {
		RESV_LIST(state, status) {
			state.resv_list = status;
		},
		// SET_CLINIC(state, status) {
		//   localStorage.setItem('clinic', JSON.stringify(status));
		// },
		SET_AIRLEE_CUSTOMER(state, status) {
			const { data, clinicCode } = status;
			localStorage.setItem(`customer_${clinicCode}`, JSON.stringify(data));
		},
		SET_AIRLEE_REGISTRATIONS(state, status) {
			const { registrations, clinicCode } = status;
			localStorage.setItem(
				`registrations_airlee_${clinicCode}`,
				JSON.stringify(registrations),
			);
		},
		SET_AIRLEE_NEWPATIENT(state, status) {
			const { data, clinicCode } = status;
			localStorage.setItem(`newpatient_${clinicCode}`, JSON.stringify(data));
		},
		SET_AIRLEE_NNP(state, status) {
			const { nnp, clinicCode } = status;
			const { birthday, mobile, name } = nnp;
			localStorage.setItem(
				`nnp_${clinicCode}`,
				JSON.stringify({ birthday, mobile, name }),
			);
		},
		SET_MED(state, status) {
			const { data, clinicCode } = status;
			localStorage.setItem(`med_airlee_${clinicCode}`, JSON.stringify(data));
		},
		SET_MED_BOOKING(state, status) {
			const { data, clinicCode } = status;
			localStorage.setItem(
				`med_booking_airlee_${clinicCode}`,
				JSON.stringify(data),
			);
		},
		SET_MED_PART(state, status) {
			const { data, clinicCode } = status;
			localStorage.setItem(
				`med_part_airlee_${clinicCode}`,
				JSON.stringify(data),
			);
		},
		SET_MED_PROBLEM(state, status) {
			const { data, clinicCode } = status;
			localStorage.setItem(
				`med_problem_airlee_${clinicCode}`,
				JSON.stringify(data),
			);
		},
		SET_ROOM(state, status) {
			const { data, clinicCode } = status;
			localStorage.setItem(`room_airlee_${clinicCode}`, JSON.stringify(data));
		},
		SET_BOOKING(state, status) {
			const { data, clinicCode } = status;
			localStorage.setItem(
				`booking_airlee_${clinicCode}`,
				JSON.stringify(data),
			);
		},
		SET_TIME(state, status) {
			const { data, clinicCode } = status;
			localStorage.setItem(`time_airlee_${clinicCode}`, JSON.stringify(data));
		},
		SET_NOTE(state, status) {
			const { data, clinicCode } = status;
			localStorage.setItem(`note_airlee_${clinicCode}`, data);
		},
		SET_CUS_NOTE(state, status) {
			const { data, clinicCode } = status;
			localStorage.setItem(`cus_note_airlee_${clinicCode}`, data);
		},
		SET_PARTS(state, status) {
			const { data, clinicCode } = status;
			localStorage.setItem(`parts_airlee_${clinicCode}`, data);
		},
		REGISTRATIONS(state, status) {
			const { registrations, clinicCode } = status;
			localStorage.setItem(
				`registrations_airlee_${clinicCode}`,
				JSON.stringify(registrations),
			);
			state.registrations = registrations;
		},
		RM_REGISTRATION(state, status) {
			const { data, clinicCode } = status;
			const newArr = [];
			const registrations = JSON.parse(
				localStorage.getItem(`registrations_airlee_${clinicCode}`),
			);
			registrations.forEach((item) => {
				if (item.id !== data) {
					newArr.push(item);
				}
			});
			localStorage.setItem(
				`registrations_airlee_${clinicCode}`,
				JSON.stringify(newArr),
			);
			// state.registrations = newArr;
		},
		RESV(state, status) {
			const { data, clinicCode } = status;
			localStorage.setItem(`resv_airlee_${clinicCode}`, JSON.stringify(data));
			state.resv = data;
		},
	},
	getters: {
		resv_list(state) {
			return state.resv_list;
		},
		// clinic() {
		//   return JSON.parse(localStorage.getItem('clinic'));
		// },
		medByC: () => (clinicCode) => {
			const med = localStorage.getItem(`med_airlee_${clinicCode}`);
			if (med && med !== 'undefined') {
				return JSON.parse(med);
			} else {
				return undefined;
			}
		},
		medPartByC: () => (clinicCode) => {
			const medPart = localStorage.getItem(`med_part_airlee_${clinicCode}`);
			if (medPart && medPart !== 'undefined') {
				return JSON.parse(medPart);
			} else {
				return undefined;
			}
		},
		medProblemByC: () => (clinicCode) => {
			const medProblem = localStorage.getItem(
				`med_problem_airlee_${clinicCode}`,
			);
			if (medProblem && medProblem !== 'undefined') {
				return JSON.parse(medProblem);
			} else {
				return undefined;
			}
		},
		roomByC: () => (clinicCode) => {
			const room = localStorage.getItem(`room_airlee_${clinicCode}`);
			if (room) {
				return JSON.parse(room);
			} else {
				return {};
			}
		},
		bookingByC: () => (clinicCode) => {
			const booking = localStorage.getItem(`booking_airlee_${clinicCode}`);
			if (booking) {
				return JSON.parse(booking);
			} else {
				return {};
			}
		},
		timeByC: () => (clinicCode) => {
			const time = localStorage.getItem(`time_airlee_${clinicCode}`);
			if (time) {
				return JSON.parse(time);
			} else {
				return {};
			}
		},
		noteByC: () => (clinicCode) => {
			const note = localStorage.getItem(`note_airlee_${clinicCode}`);
			if (note) {
				return note;
			} else {
				return '';
			}
		},
		cusNoteByC: () => (clinicCode) => {
			const cusNote = localStorage.getItem(`cus_note_airlee_${clinicCode}`);
			if (cusNote) {
				return cusNote;
			} else {
				return '';
			}
		},
		partsByC: () => (clinicCode) => {
			const parts = localStorage.getItem(`parts_airlee_${clinicCode}`);
			if (parts) {
				return parts.split(',');
			} else {
				return [];
			}
		},
		registrationsByC: () => (clinicCode) => {
			const registrations = localStorage.getItem(
				`registrations_airlee_${clinicCode}`,
			);
			if (registrations) {
				return JSON.parse(registrations);
			} else {
				return {};
			}
		},
		resvByC: () => (clinicCode) => {
			const resv = localStorage.getItem(`resv_airlee_${clinicCode}`);
			if (resv) {
				return JSON.parse(resv);
			} else {
				return {};
			}
		},
	},
};
